export type GitHubDeviceFlowStatus='pending'|'connected'|'expired'|'failed'

export type GitHubConnectionStatus={
  client_id_configured:boolean
  token_configured:boolean
  repository:string
  login?:string
}

export type GitHubDeviceFlow={
  flow_id:string
  status:GitHubDeviceFlowStatus
  user_code?:string
  verification_uri?:string
  expires_at:number
  interval:number
  login?:string
  message?:string
}

export type GitHubDeviceFlowUpdate=Omit<GitHubDeviceFlow,'flow_id'>&{flow_id?:string}

export const githubDeviceFlowBody:Record<string,never>={}

export function githubDevicePollDelay(interval:number|undefined):number{
  const seconds=Number.isFinite(interval)&&Number(interval)>0?Number(interval):5
  return Math.min(30,Math.max(1,seconds))*1000
}

export function githubTimestampMilliseconds(value:number):number{
  return value>0&&value<1_000_000_000_000?value*1000:value
}

export function isTerminalGitHubDeviceFlow(status:GitHubDeviceFlowStatus):boolean{
  return status!=='pending'
}

export function mergeGitHubDeviceFlow(current:GitHubDeviceFlow,update:GitHubDeviceFlowUpdate):GitHubDeviceFlow{
  return {
    ...current,
    ...update,
    flow_id:update.flow_id??current.flow_id,
    user_code:update.user_code??current.user_code,
    verification_uri:update.verification_uri??current.verification_uri,
  }
}
